export enum LivanceApiPaymentMethod {
  CreditCard = "cartao_credito",
  Boleto = "boleto",
  PJ = "pj",
}
